import { useState } from "react";
import { Inbox, Wrench, Kanban, Smartphone, Sparkles, Wallet, Package, Users, Cloud, Menu, LogOut } from "lucide-react";
import { useAuth } from "./AuthContext.jsx";

const NAV = [
  { id: "anfragen", label: "Anfragen", Icon: Inbox },
  { id: "auftraege", label: "Aufträge", Icon: Wrench },
  { id: "pipeline", label: "Pipeline", Icon: Kanban },
  { id: "social", label: "Social Media", Icon: Smartphone },
  { id: "ki", label: "KI-Tools", Icon: Sparkles },
  { id: "kosten", label: "Kosten", Icon: Wallet },
  { id: "material", label: "Material", Icon: Package },
  { id: "team", label: "Team & Aufgaben", Icon: Users },
];

const SOCIAL = [
  { label: "Instagram", url: "https://www.instagram.com/darlux.design" },
  { label: "TikTok", url: "https://www.tiktok.com/@darlux.design" },
  { label: "YouTube", url: "https://www.youtube.com/@darluxdesignDE" },
  { label: "Facebook", url: "https://www.facebook.com/profile.php?id=61586843116930" },
];

export default function Layout({ active, onNavigate, children }) {
  const { user, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  const navigate = (id) => {
    onNavigate(id);
    setMobileOpen(false);
  };

  return (
    <div className="dx-layout">
      <button className="dx-mobile-toggle" onClick={() => setMobileOpen(true)}><Menu size={18} /> Menü</button>

      {mobileOpen ? <div className="dx-scrim" onClick={() => setMobileOpen(false)} /> : null}

      <aside className={"dx-sidebar" + (mobileOpen ? " dx-sidebar--open" : "")}>
        <div className="dx-sidebar-header"><img src="/darlux-logo.png" alt="Darlux Design" className="dx-logo-img" /></div>
        <nav className="dx-nav">
          {NAV.map((n) => (
            <button
              key={n.id}
              className={"dx-nav-item" + (active === n.id ? " dx-nav-item--active" : "")}
              onClick={() => navigate(n.id)}
            >
              <n.Icon size={18} /> {n.label}
            </button>
          ))}
        </nav>
        <div className="dx-sidebar-footer">
          <a href="https://cloud.darlux-design.de/apps/dashboard/" target="_blank" rel="noopener" className="dx-footer-link">
            <Cloud size={16} /> Nextcloud
          </a>
          <div className="dx-social-row">
            {SOCIAL.map((s) => (
              <a key={s.label} href={s.url} target="_blank" rel="noopener" title={s.label} className="dx-social-link">
                {s.label[0]}
              </a>
            ))}
          </div>
          <div className="dx-user-row">
            <span>{user?.displayName}</span>
            <button onClick={logout} className="dx-logout-btn"><LogOut size={13} /> Logout</button>
          </div>
        </div>
      </aside>

      <main className="dx-main">
        <header className="dx-topbar">
          <span className="dx-topbar-title">{NAV.find((n) => n.id === active)?.label}</span>
          <img src="/darlux-logo.png" alt="Darlux Design" className="dx-topbar-logo-img" />
        </header>
        <div className="dx-content">{children}</div>
      </main>
    </div>
  );
}
